'use strict';

var Backbone = require('backbone');
var _ = require('underscore');
var config = require('../../../js/config');
var template = require('../templates/_AutoCompleteResults.hbs');
import utilities from '../../../js/utilities';
import mediator from '../../../js/mediator';
import templateRecent from '../templates/_RecentSearches.hbs';
import PromoGroupService from '../../../services/PromoGroupService'
import * as globalisation from '../../../utilities/globalisation';
import * as featureFlags from '../../../utilities/featureFlags';

var AutoCompleteView = Backbone.View.extend({

  events: {
    keyup: 'keyUp'
  },

  initialize: function() {
    this.bindMediatorEvents();
    this.initializeTranslations();
    PromoGroupService.processFeatureFlagsForAutoComplete();

    // Import typeahead from the barrel
    require('../../Typeahead');
  },

  bindMediatorEvents: function() {
    mediator.on(config.events.search.typeaheadDisplayResults, _.throttle(this.renderResults, 20), this);
    mediator.on(config.events.search.typeaheadDisplayRecentSearches, this.renderPastSearches, this);
    mediator.on(config.events.search.typeaheadHighlightQuery, this.highlightQuery, this);
  },

  initializeTranslations: function() {

    // Translations keys to pass to the view for dynamic categories
    this.translations = {
      products: {
        domain: 'typeahead',
        key: 'productsLabel'
      },
      productLines: {
        domain: 'megaMenu',
        key: 'productCategoriesLabel'
      },
      descriptions: {
        domain: 'product',
        key: 'description'
      },
      manufacturers: {
        domain: 'product',
        key: 'manufacturer'
      }
    };
  },

  renderResults: function(search) {
    // Save variables in more legible variables
    let query = search.query;
    let sections = search.results;
    let resultsCount = search.resultsCount;
    let results = {};
    let storedFilter = utilities.localStorageLoad(config.events.search.localStorageInstockFilter);
    storedFilter = JSON.parse(storedFilter);

    // Iterate over each category
    _.each(Object.keys(sections), (name) => {

      // pull out the section so we can iterate over it later
      let section = sections[name];

      results[name] = [];

      // If we don't have any entries, bail out of the loop
      if (!section) {
        return;
      }

      // Iterate over each item in each category
      _.each(section, (item) => {

        let resultTemplate = item.text.replace(query, '<strong>$1</strong>');

        if (featureFlags.EnableAutoCompleteNewProductPromoGroup.isEnabled()) {

          let promoGroupKey = PromoGroupService.determinePromoGroupForAutoComplete(item);
          let translatedPromoGroup = promoGroupKey && this.translateIndicator(promoGroupKey);
          if (translatedPromoGroup && item.promoGroup === 'Sponsored') {
            resultTemplate = item.text.replace(query, '<strong>$1</strong>') + ' ' +
              '<span class=\'Typeahead-sponsored\'>' + translatedPromoGroup + '</span>';
          }
          else if (translatedPromoGroup) {
            resultTemplate = item.text.replace(query, '<strong>$1</strong>') + ' ' +
              '<span class=\'Typeahead-new-indicator\'>' + translatedPromoGroup + '</span>';
          }
        }

        // Push our result to our results array
        if (storedFilter) {
          results[name].push({
            id: item.text,
            searchUrl: item.searchUrl + storedFilter,
            html: resultTemplate
          });
        } else {
          results[name].push({
            id: item.text,
            searchUrl: item.searchUrl,
            html: resultTemplate
          });
        }
      });
    });

    // Setup
    let viewData = {
      query,
      resultsCount,
      results,
      translations: this.translations
    };

    // If we don't have any results, we want to show some categories for the user to navigate with
    if (resultsCount === 0) {
      // Save variables for legibility
      let searchUrl = config.urls.search;
      let searchQuery;
      if (storedFilter) {
        searchQuery = { q: query + storedFilter };
      } else {
        searchQuery = { q: query };
      }

      // Build search category urls
      _.extend(viewData, {
        resultsInProducts: utilities.urlTemplate(searchUrl.products, searchQuery),
        resultsInDatasheets: utilities.urlTemplate(searchUrl.datasheets, searchQuery),
        resultsInRefDesigns: utilities.urlTemplate(searchUrl.refDesigns, searchQuery),
        resultsInResearchAndEvents: utilities.urlTemplate(searchUrl.researchAndEvents, searchQuery)
      })
    }

    // set our dropdown html and pass it our viewData
    this.$el.html(template(viewData, {data: {config: config}}));

  },

  translateIndicator: function(promoGroupKey) {
    let promoTranslation = globalisation.pluraliseAndTranslate('productSearch', promoGroupKey);
    promoTranslation = promoTranslation.replace('[', '').replace(']', '');
    return promoTranslation;
  },

  renderPastSearches: function() {
    let stored = utilities.localStorageLoad(config.events.search.localStorageTypeAhead);
    stored = JSON.parse(stored);

    let storedFilter = utilities.localStorageLoad(config.events.search.localStorageInstockFilter);
    storedFilter = JSON.parse(storedFilter);

    _.forEach(stored, (storedElement) => {
      let searchUrl = config.urls.search;
      let searchQuery;
      if (storedFilter) {
        searchQuery = { q: storedElement.text + storedFilter };
      } else {
        searchQuery = { q: storedElement.text };
      }
      storedElement.url = utilities.urlTemplate(searchUrl.products, searchQuery);
    });
    this.$el.html(templateRecent(stored));
  },

  highlightQuery: function(index) {

    let isActive = config.classes.isActive;

    // find all search results that are active ( we should only have one, but for safe measures, lets remove it )
    this.$el.find('.' + isActive).removeClass(isActive);

    // Round up all of our search results then find the one we want by it's index in our array
    let $result = this.$el.find('.TypeaheadAutocomplete-result').eq(index);

    // Add the isActive class
    $result.addClass(isActive);

    // Fire highlighted query for whoever cares and pass the result text through
    // This happens to be used for changing the text in the search bar
    mediator.trigger(config.events.search.typeaheadHighlightedQuery, $result.find('a strong').text());
    var searchBarInputs = $('.Search-bar-select-input');
    for (var i = 0; i < searchBarInputs.length; i++) {
      searchBarInputs[i].value = $result.find('a').text();
    }
  },

  keyUp: function(e) {
    // User has pressed the escape key, let's close the menu
    if (e.keyCode === config.key.escape) {
      this.trigger(config.events.search.close);
    }
  },

  show: function() {
    // Show our autocomplete drop down
    this.$el.addClass(config.classes.isVisible);
  },

  hide: function() {
    // Hide our autocomplete drop down
    this.currentQuery = null;
    this.$el.removeClass(config.classes.isVisible);

    // Remove all child dom elements from our $el
    this.$el.empty();
  }

});

module.exports = AutoCompleteView;



// WEBPACK FOOTER //
// ./assets/components/Typeahead/views/AutoCompleteView.js